import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "md:flex justify-between" }
const _hoisted_2 = { class: "md:shrink-5 w-auto flex items-stretch" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-col gap-y-1 pl-5 md:pl-0" }
const _hoisted_5 = { class: "text-xl font-[550]" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-sm text-slate-600" }
const _hoisted_8 = { class: "font-medium text-slate-700" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-slate-600"
}
const _hoisted_10 = { class: "font-medium text-slate-700" }
const _hoisted_11 = {
  key: 1,
  class: "text-sm text-emerald-700"
}
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = {
  key: 2,
  class: "table-fixed"
}
const _hoisted_14 = { class: "w-2/5" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "Select" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = { class: "flex flex-col pb-2 basis-1/5 my-5 p-4 gap-1" }

import { instrumentI } from "@/interfaces/interfaces";
import { computed, onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Cards',
  props: {
    instrument: {},
    language: {},
    mode: {}
  },
  emits: ["update:vervangen", "update:kalibreren", "update:Niet_meer_in_gebruik", "update:selectedVervanging", "update:changeBattery", "serviceverzoek"],
  setup(__props: any) {

const selectedVervanging = ref();
const changeBattery = ref(false);

const props = __props;



const translations: { [key: string]: { [key: string]: string } } = {
  nl: {
    referentie: "Referentie",
    serienummer: "Serienummer",
    certificaat: "Certificaat",
    verloopdatum: "Verloopdatum",
    eersteAanschafdatum: "Verkoopdatum",
    vervangenDoor: "Vervangen door",
    kostenKalibratie: "Kosten Kalibratie",
    batterijVervangen: "Batterij vervangen",
    vervangen: "Vervangen",
    kalibreren: "Kalibreren",
    nietMeerInGebruik: "Niet meer in gebruik",
    serviceverzoek: "Serviceverzoek",
    serviceverzoekIngediend: "Serviceverzoek in behandeling sinds",
  },
  fr: {
    referentie: "Référence",
    serienummer: "Numéro de série",
    certificaat: "Certificat",
    verloopdatum: "Échéance",
    eersteAanschafdatum: "Date de vente",
    vervangenDoor: "Remplacé par",
    kostenKalibratie: "Coûts de calibration",
    batterijVervangen: "Remplacement de la batterie",
    vervangen: "Remplacer",
    kalibreren: "Calibrer",
    nietMeerInGebruik: "N'est plus en usage",
    serviceverzoek: "Demande de service",
    serviceverzoekIngediend: "Demande de service en cours de traitement depuis le",
  },
  en: {
    referentie: "Reference",
    serienummer: "Serial number",
    certificaat: "Certificate",
    verloopdatum: "Expiration date",
    eersteAanschafdatum: "Date of sale",
    vervangenDoor: "Replaced by",
    kostenKalibratie: "Calibration cost",
    batterijVervangen: "Battery replacement",
    vervangen: "Replace",
    kalibreren: "Calibrate",
    nietMeerInGebruik: "No longer in use",
    serviceverzoek: "Service request",
    serviceverzoekIngediend: "Service request being processed since",
  },
  de: {
    referentie: "Referenz",
    serienummer: "Seriennummer",
    certificaat: "Zertifikat",
    verloopdatum: "Ablaufdatum",
    eersteAanschafdatum: "Verkaufsdatum",
    vervangenDoor: "Ersetzt durch",
    kostenKalibratie: "Kalibrierungskosten",
    batterijVervangen: "Batteriewechsel",
    vervangen: "Ersetzen",
    kalibreren: "Kalibrieren",
    nietMeerInGebruik: "Außer Betrieb",
    serviceverzoek: "Serviceanfrage",
    serviceverzoekIngediend: "Serviceanfrage in Bearbeitung seit",
  },
};

const mode = computed(() => props.mode ?? "kalibratieoproep");
const certificateDate = props.instrument.Certificaat ? new Date(props.instrument.Certificaat) : null;
const offset = certificateDate ? certificateDate.getTimezoneOffset() / 60 : 0;
const certificaat = certificateDate ? certificateDate.addHours(offset).toLocaleDateString() : "";
const verloopdatum = props.instrument.Verloopdatum
  ? new Date(props.instrument.Verloopdatum).addHours(offset)
  : null;
const today = new Date().addHours(offset);
const verlopen = verloopdatum ? verloopdatum < today : false;
const can_be_changed = (props.instrument.Vervangen_door?.length ?? 0) > 0;
const serviceVerzoekDatum = computed(() => {
  const value = props.instrument.serviceVerzoekInstuurdatum;
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString();
});
const eersteAanschafdatum = computed(() => {
  const value = props.instrument.Eerste_aanschafdatum;
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString();
});

function setValues() {
  selectedVervanging.value = props.instrument.selectedVervanging
    ? props.instrument.selectedVervanging
    : "";
  changeBattery.value = props.instrument.changeBattery ? props.instrument.changeBattery : false;
}

const getTranslatedText = (key: string) => {
  return translations[props.language][key];
};

const getImageData = (afbeelding?: string | null) => {
  if (afbeelding) {
    return "data:image/png;base64," + afbeelding;
  } else {
    return "../assets/1.jpg";
  }
};

onMounted(async () => {
  setValues();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white rounded-xl shadow-md overflow-hidden w-full h-auto md:h-auto", {
      'border-2 border-rose-600': __props.instrument.Error,
      'lg:h-48': mode.value === 'kalibratieoproep',
      'lg:min-h-36': mode.value === 'instrumenten',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: getImageData(__props.instrument.Afbeelding),
          alt: "Photo placeholder",
          class: _normalizeClass(["h-1/2 w-1/2 place-self-center mr-auto ml-auto object-cover object-center", {
            'md:h-48 md:w-48': mode.value === 'kalibratieoproep',
            'md:h-36 md:w-36': mode.value === 'instrumenten',
          }])
        }, null, 10, _hoisted_3)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["basis-3/6 pb-2 flex flex-col", {
          'justify-between': mode.value === 'kalibratieoproep',
          'justify-center': mode.value === 'instrumenten',
        }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.instrument.Instrumentnaam), 1),
          (mode.value === 'kalibratieoproep' && __props.instrument.Klantreferentie)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("i", null, _toDisplayString(getTranslatedText("referentie")) + " " + _toDisplayString(__props.instrument.Klantreferentie), 1)
              ]))
            : _createCommentVNode("", true),
          (mode.value === 'instrumenten')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(getTranslatedText("serienummer")) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(__props.instrument.Serienummer), 1)
                ]),
                (eersteAanschafdatum.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(getTranslatedText("eersteAanschafdatum")) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(eersteAanschafdatum.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (serviceVerzoekDatum.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(getTranslatedText("serviceverzoekIngediend")), 1),
                      _createTextVNode(" " + _toDisplayString(serviceVerzoekDatum.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("table", _hoisted_13, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_14, _toDisplayString(getTranslatedText("serienummer")), 1),
                    _createElementVNode("td", null, _toDisplayString(__props.instrument.Serienummer), 1)
                  ]),
                  (mode.value === 'kalibratieoproep' && _unref(certificaat))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                        _createElementVNode("td", null, _toDisplayString(getTranslatedText("certificaat")), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(certificaat)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (mode.value === 'kalibratieoproep' && _unref(verloopdatum))
                    ? (_openBlock(), _createElementBlock("tr", {
                        key: 1,
                        class: _normalizeClass({ 'text-red-500 font-bold': _unref(verlopen) })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(getTranslatedText("verloopdatum")), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(verloopdatum)?.toLocaleDateString()), 1)
                      ], 2))
                    : _createCommentVNode("", true),
                  (mode.value === 'kalibratieoproep' && can_be_changed && __props.instrument.Vervangen)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                        _createElementVNode("td", _hoisted_17, _toDisplayString(getTranslatedText("vervangenDoor")), 1),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            class: "border border-black-500 w-3/4 border border-gray-100 hover:border-gray-300 px-1 py-1 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedVervanging).value = $event)),
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:selectedVervanging', selectedVervanging.value)))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.instrument.Vervangen_door, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.id,
                                value: item
                              }, _toDisplayString(item.description) + " (€" + _toDisplayString(item.verkoopprijs) + ") ", 9, _hoisted_18))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, selectedVervanging.value]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                  mode.value === 'kalibratieoproep' &&
                  __props.instrument.Kalibreren &&
                  __props.instrument.Kalibratie_kosten
                )
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                        _createElementVNode("td", null, _toDisplayString(getTranslatedText("kostenKalibratie")), 1),
                        _createElementVNode("td", null, "€" + _toDisplayString(__props.instrument.Kalibratie_kosten), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
                  mode.value === 'kalibratieoproep' &&
                  __props.instrument.Kalibreren &&
                  __props.instrument.Batterij_vervangbaar
                )
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                        _createElementVNode("td", null, _toDisplayString(getTranslatedText("batterijVervangen")), 1),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((changeBattery).value = $event)),
                            class: "w-4 h-4",
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:changeBattery', changeBattery.value)))
                          }, null, 544), [
                            [_vModelCheckbox, changeBattery.value]
                          ]),
                          _createElementVNode("span", null, "   €" + _toDisplayString(__props.instrument.Batterij_vervangen_kosten), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ], 2),
      _createElementVNode("div", _hoisted_21, [
        (mode.value === 'kalibratieoproep')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", null, [
                can_be_changed
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:vervangen', true))),
                      class: _normalizeClass(["inline-flex items-center outline-1 w-full md:w-48 border border-black-500 cursor-pointer hover:bg-gullimex-orange px-3 py-2 inline-block hover:text-white rounded", {
                'bg-gullimex-orange': __props.instrument.Vervangen,
                'text-white': __props.instrument.Vervangen,
                'bg-white': !__props.instrument.Vervangen,
                'text-black': !__props.instrument.Vervangen,
              }])
                    }, _toDisplayString(getTranslatedText("vervangen")), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:kalibreren', true))),
                  class: _normalizeClass(["inline-flex items-center border border-black-500 w-full md:w-48 cursor-pointer hover:bg-gullimex-orange px-3 py-2 inline-block hover:text-white rounded", {
                'bg-gullimex-orange': __props.instrument.Kalibreren,
                'text-white': __props.instrument.Kalibreren,
                'bg-white': !__props.instrument.Kalibreren,
                'text-black': !__props.instrument.Kalibreren,
              }])
                }, _toDisplayString(getTranslatedText("kalibreren")), 3)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:Niet_meer_in_gebruik', true))),
                  class: _normalizeClass(["inline-flex items-center w-full md:w-48 border border-black-500 cursor-pointer hover:bg-gullimex-orange px-3 py-2 inline-block hover:text-white rounded", {
                'bg-gullimex-orange': __props.instrument.Niet_meer_in_gebruik,
                'text-white': __props.instrument.Niet_meer_in_gebruik,
                'bg-white': !__props.instrument.Niet_meer_in_gebruik,
                'text-black': !__props.instrument.Niet_meer_in_gebruik,
              }])
                }, _toDisplayString(getTranslatedText("nietMeerInGebruik")), 3)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('serviceverzoek'))),
                  class: "inline-flex items-center w-full md:w-48 border border-black-500 cursor-pointer bg-white px-3 py-2 text-black transition hover:bg-gullimex-orange hover:text-white rounded"
                }, _toDisplayString(getTranslatedText("serviceverzoek")), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:Niet_meer_in_gebruik', true))),
                  class: _normalizeClass(["inline-flex items-center w-full md:w-48 border border-black-500 cursor-pointer hover:bg-gullimex-orange px-3 py-2 inline-block hover:text-white rounded", {
                'bg-gullimex-orange': __props.instrument.Niet_meer_in_gebruik,
                'text-white': __props.instrument.Niet_meer_in_gebruik,
                'bg-white': !__props.instrument.Niet_meer_in_gebruik,
                'text-black': !__props.instrument.Niet_meer_in_gebruik,
              }])
                }, _toDisplayString(getTranslatedText("nietMeerInGebruik")), 3)
              ])
            ], 64))
      ])
    ])
  ], 2))
}
}

})